import {
  ArrowLeftRight,
  FileCheck2,
  ScanLine,
  BadgePlus,
  Copy,
  ShieldCheck,
  Handshake,
  Calculator,
  TriangleAlert,
  PencilRuler,
  Siren,
  MessageCircle,
} from 'lucide-react';
import { Reveal } from './Reveal';
import { services, waLink } from '../data/site';

const ICONS = {
  transferencia: ArrowLeftRight,
  licenciamento: FileCheck2,
  emplacamento: ScanLine,
  'primeiro-emplacamento': BadgePlus,
  'segunda-via': Copy,
  regularizacao: ShieldCheck,
  'comunicacao-venda': Handshake,
  'consulta-debitos': Calculator,
  'consulta-multas': TriangleAlert,
  'alteracao-dados': PencilRuler,
  'alvara-liberacao': Siren,
};

export const Services = () => (
  <section
    id="servicos"
    data-testid="services-section"
    className="relative py-24 sm:py-32 bg-white"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="text-xs font-mono uppercase tracking-[0.25em] text-blue-600 mb-4">
          01 — O que eu resolvo
        </p>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-900 max-w-2xl leading-tight">
          Toda a burocracia do seu veículo,{' '}
          <span className="text-blue-600">em um só lugar.</span>
        </h2>
        <p className="mt-5 max-w-xl text-slate-500 text-sm sm:text-base">
          Toque em qualquer serviço e fale direto comigo no WhatsApp — a
          mensagem já vai pronta.
        </p>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
        {services.map((service, i) => {
          const Icon = ICONS[service.id];
          return (
            <Reveal
              key={service.id}
              delay={(i % 3) * 0.08}
              className={service.span ? 'lg:col-span-2' : ''}
            >
              <a
                data-testid={`service-card-${service.id}`}
                href={waLink(service.waMessage)}
                target="_blank"
                rel="noopener noreferrer"
                className="card-glow group relative flex flex-col justify-between h-full min-h-[190px] rounded-2xl border border-slate-200 bg-white p-6 sm:p-7"
              >
                <div className="flex items-start justify-between gap-4">
                  <div className="w-11 h-11 rounded-xl bg-blue-50 border border-blue-200 flex items-center justify-center text-blue-600 transition-colors duration-300 group-hover:bg-blue-100">
                    <Icon size={21} />
                  </div>
                  <span className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-400 border border-slate-200 rounded-full px-3 py-1">
                    {service.category}
                  </span>
                </div>
                <div className="mt-6">
                  <h3 className="font-display font-bold text-lg sm:text-xl text-slate-900">
                    {service.title}
                  </h3>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">
                    {service.description}
                  </p>
                </div>
                <span
                  data-testid={`service-whatsapp-button-${service.id}`}
                  className="mt-5 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-blue-600 opacity-0 translate-y-2 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0"
                >
                  <MessageCircle size={14} />
                  Chamar no WhatsApp
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
